import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { LandingPage } from './pages/LandingPage';
export function App() {
  return <HelmetProvider data-id="element-0">
      <LandingPage data-id="element-1" />
    </HelmetProvider>;
}